import LinePieChart from "common/components/LinePieChart/LinePieChart";
import SubTitle from "components/SubTitle";
import { ReportCompletedByControlCenterDetails } from "pages/Dashboards/AdministrativeDashboard/types";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomBarChart from "common/components/BarChart/CustomBarChart";
import {
  getReportsCompletedPerControllerForBarChart,
  getReportsSentDataForPieChart,
  periodStrings,
} from "./utils";

type Props = {
  data: ReportCompletedByControlCenterDetails;
  period: string;
};

const ReportsCompletedPerControlCenter = ({ data, period }: Props) => {
  const { t } = useTranslation();
  const completedPerController = getReportsCompletedPerControllerForBarChart(
    data?.reportCompletedPerControlCenter
  );

  return (
    <div className="chart-container data-box">
      <div className="dashed-inner-border">
        <div className="title-row">
          <SubTitle className="title">{t("reportsThatCompleted")}</SubTitle>
          <div className="title-data">
            <LinePieChart
              innerRadius={15}
              outerRadius={20}
              data={getReportsSentDataForPieChart(
                data?.totalReportCompletedByControlCenterPercentage
              )}
              percent={data?.totalReportCompletedByControlCenterPercentage}
            />
            <div className="column">
              <p className="total">
                {t("totalByPeriod")} {periodStrings[period]}
              </p>
              <p className="amount">
                {data?.totalReportCompletedByControlCenter}
              </p>
            </div>
          </div>
        </div>
        <CustomBarChart data={completedPerController} period={period} />
      </div>
    </div>
  );
};
export default ReportsCompletedPerControlCenter;
